<template>
    <div id="conditionModal" class="modal fade" role="dialog" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <!-- Modal content-->
            <div class="modal-content schedule-modal">
                <div class="modal-header">
                    <h5 class="text-center mb-2">Select Condition</h5>
                    <button type="button" dusk="modal-close-button"
                            class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                            data-dismiss="modal"
                            @click="closeModal">close
                    </button>
                </div>
                <div class="modal-body text-dark p-0">
                    <div class="flex justify-center">
                        <div class="container mt-4">
                            <div v-for="(item, key) in conditions">
                                <div class="row">
                                    <div class="col-md-4">
                                        <b-form-select v-model="form.automation_field" v-if="form.automation_object === 'project'" class="mb-3" id="project_select" @change="selectField">
                                            <b-form-select-option value="empty" id="project-empty">Please select an option</b-form-select-option>
                                            <b-form-select-option v-for="(item, index) in allProjectFields" :value="item.property_name" :key="'project'+index">{{ item.name }}</b-form-select-option>
                                        </b-form-select>
                                        <b-form-select v-model="form.automation_field" v-if="form.automation_object === 'company'" class="mb-3" id="company_select" @change="selectField">
                                            <b-form-select-option value="empty" id="company-empty">Please select an option</b-form-select-option>
                                            <b-form-select-option v-for="(item, index) in allCompanyFields" :value="item.property_name" :key="'company'+index">{{ item.name }}</b-form-select-option>
                                        </b-form-select>
                                        <b-form-select v-model="form.automation_field" v-if="form.automation_object === 'contact'" class="mb-3" id="contact_select" @change="selectField">
                                            <b-form-select-option value="empty" id="contact-empty">Please select an option</b-form-select-option>
                                            <b-form-select-option v-for="(item, index) in allContactFields" :value="item.property_name" :key="'contact'+index">{{ item.name }}</b-form-select-option>
                                        </b-form-select>
                                    </div>

                                    <div class="col-md-3">
                                        <b-form-select v-model="form.trigger_operator" class="mb-3" @change="triggerOperatorChanged">
                                            <b-form-select-option value="equal to" selected>is equal to</b-form-select-option>
                                            <b-form-select-option value="not equal to">is not equal to</b-form-select-option>
                                        </b-form-select>
                                    </div>

                                    <div class="col-md-4">
                                        <input class="form-control-sm field-height" type="text" v-if="form.field_object.type === 'text'" v-model="item.automationValue" key="text">

                                        <b-form-select class="form-control-sm field-height" v-if="form.field_object.type === 'dropdown' && !form.field_object.is_custom_field" v-model="item.automationValue">
                                            <b-form-select-option value="empty" id="filter-empty1">Please select an option</b-form-select-option>
                                            <b-form-select-option v-for="(item, index) in dropdownOptions" :value="item.id" :key="'filter'+index">{{ item.code }}</b-form-select-option>
                                        </b-form-select>

                                        <b-form-select class="form-control-sm field-height" v-if="form.field_object.type === 'dropdown' && form.field_object.is_custom_field" v-model="item.automationValue">
                                            <b-form-select-option value="empty" id="filter-empty1">Please select an option</b-form-select-option>
                                            <b-form-select-option v-for="(item, index) in dropdownOptions" :value="item.id" :key="'filter'+index">{{ item.name }}</b-form-select-option>
                                        </b-form-select>

                                        <b-form-select class="form-control-sm field-height" v-if="form.field_object.type === 'user'" v-model="item.automationValue">
                                            <b-form-select-option value="empty" id="user-empty1">Please select an option</b-form-select-option>
                                            <b-form-select-option v-for="(item, index) in dropdown_user_values" :value="item.id" :key="'user'+index">{{ item.name }}</b-form-select-option>
                                        </b-form-select>

                                        <input type="text" name="contact_phone"
                                               v-if="form.field_object.type === 'phone'"
                                               key="phone"
                                               v-mask="['(###) ###-####', '(###) ###-#### ext. #####']"
                                               id="contact_phone1"
                                               class="form-control-sm field-height"
                                               v-model="item.automationValue">

                                        <currency-input
                                            v-if="form.field_object.type === 'money'"
                                            id="contract_amount1"
                                            name="contract_amount"
                                            locale="us"
                                            :currency="null"
                                            class="form-control-sm field-height"
                                            v-model="item.automationValue">
                                        </currency-input>

                                        <datepicker
                                            v-if="form.field_object.type === 'date'"
                                            :format="'MM/dd/yyyy'" :use-utc="true"
                                            wrapper-class="field-height form-control-sm"
                                            v-model="item.automationValue"
                                            input-class="date-picker-ui"
                                        ></datepicker>
                                    </div>

                                    <div v-if="conditions.length > 1" class="col-lg-1">
                                        <button class="btn btn-sm btn-light-red" @click="removeConditionRow(key)">
                                            <i class="fa fa-trash" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </div>
                                <div v-if="form.trigger_operator === 'equal to' && key <= 3" class="d-flex align-items-center justify-content-center mb-3">
                                    <p class="font-bold">OR</p>
                                </div>
                            </div>
                            <div v-if="form.trigger_operator === 'equal to' && conditions.length <= 4" class="d-flex align-items-center justify-content-center my-3">
                                <button class="btn btn-secondary" @click="addConditionRow">
                                    <i class="fa fa-plus" aria-hidden="true"></i> Add criteria
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="text-right mt-4">
                        <button class="btn btn-primary" data-dismiss="modal" @click="saveConditions">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import Datepicker from 'vuejs-datepicker';
import {CurrencyInput} from "vue-currency-input";
import Swal from "sweetalert2";
import moment from "moment/moment";

const automationConditionGeneric = {
    automationValue: null
};
export default {
    name: 'AutomationConditionModal',
    components: {Multiselect, Datepicker, CurrencyInput},
    props: ['form', 'automation', 'allProjectFields', 'allCompanyFields', 'allContactFields', 'dropdown_options',
            'dropdown_user_values', 'all_codes', 'company_types', 'contact_types', 'team_contact_statuses'],
    data() {
        return {
            conditions: [_.cloneDeep(automationConditionGeneric)],
            dropdownOptions: this.dropdown_options,
            conditionEditIndex: -1
        }
    },
    methods: {
        openModal() {
            $('#conditionModal').modal('show');
        },
        closeModal() {
            this.form.automation_field = null;
            this.form.trigger_operator = 'equal to';
            this.conditionEditIndex = -1;
            this.resetConditions();
        },
        addConditionRow() {
            if(this.validateConditions()) {
                this.conditions.push(_.cloneDeep(automationConditionGeneric));
            }
        },
        removeConditionRow(key) {
            this.conditions.splice(key, 1);
        },
        resetConditions() {
            this.conditions = [_.cloneDeep(automationConditionGeneric)];
        },
        validateConditions() {
            if(!this.form.automation_field || this.form.automation_field === '' || this.form.automation_field === 'empty') {
                this.getToast().fire({
                    type: 'error',
                    title: 'Please select condition field'
                });
                return false;
            }

            for(let i = 0; i < this.conditions.length; i++) {
                let key = i + 1;
                if(!this.conditions[i].automationValue) {
                    this.getToast().fire({
                        type: 'error',
                        title: 'Please select condition value for condition # ' + key
                    });
                    return false;
                }
            }

            return true;
        },
        selectField(item, changedFromMethod = false) {
            const self = this;

            if(!changedFromMethod) {
                _.forEach(self.conditions, (obj) => {
                    obj.automationValue = null;
                });
            }

            switch(self.form.automation_object) {
                case 'project':
                    self.$parent.$parent.setFieldObject(self.allProjectFields, item);
                    break;
                case 'company':
                    self.$parent.$parent.setFieldObject(self.allCompanyFields, item);
                    break;
                case 'contact':
                    self.$parent.$parent.setFieldObject(self.allContactFields, item);
                    break;
            }

            switch (self.form.field_object.property_name) {
                case 'sales_status_id':
                    self.dropdownOptions = self.all_codes.sales_status
                    break;
                case 'marketing_status_id':
                    self.dropdownOptions = self.all_codes.marketing_status
                    break;
                case 'lead_from_id':
                    self.dropdownOptions = self.all_codes.lead_from
                    break;
                case 'client_profile_id':
                    self.dropdownOptions = self.all_codes.client_profile
                    break;
                case 'contract_type_id':
                    self.dropdownOptions = self.all_codes.contract_type
                    break;
                case 'office_id':
                    self.dropdownOptions = self.all_codes.office
                    break;
                case 'products_and_services_id':
                    self.dropdownOptions = self.all_codes.products_and_services
                    break;
                case 'company_types_id':
                    self.dropdownOptions = self.company_types
                    break;
                case 'contact_types_id':
                    self.dropdownOptions = self.contact_types
                    break;
                case 'team_contact_status':
                    self.dropdownOptions = self.team_contact_statuses
                    break;
            }

            if(self.form.field_object.is_custom_field && ['user', 'dropdown'].includes(self.form.field_object.type)){
                self.dropdownOptions = self.form.field_object.custom_field_options
            }
        },
        saveConditions() {
            const oldFinalConditions = _.cloneDeep(this.$parent.finalConditions);
            if(this.validateConditions()) {
                let field = this.form.automation_field;
                let label = this.$parent.$parent.formatTriggerLabel(field);
                let triggerValues = [];
                let customFieldId = null;
                let salesBehaviorId = null;
                let triggerValueDisplays = [];
                let isRecordDetailCustomField = false;

                for(let i = 0; i < this.conditions.length; i++) {
                    let currentCondition = this.conditions[i];
                    triggerValues.push(currentCondition.automationValue);

                    if(this.form.field_object.is_custom_field) {
                        if(['dropdown','user'].includes(this.form.field_object.type)) {
                            const selectedOption = this.form.field_object.custom_field_options.find(x => x.id == currentCondition.automationValue);
                            triggerValueDisplays.push(selectedOption ? selectedOption.name : '');
                        }
                        else if(this.form.field_object.type === 'date') {
                            triggerValueDisplays.push(moment(currentCondition.automationValue).format('YYYY-MM-DD'));
                        }
                        else {
                            triggerValueDisplays.push(currentCondition.automationValue);
                        }

                        customFieldId = this.form.field_object.id;
                        isRecordDetailCustomField = this.form.field_object.is_record_detail_custom_field;
                    }
                    else {
                        switch(this.form.automation_field) {
                            case 'sales_status_id':
                                const salesStatus = this.all_codes.sales_status.find(element => element.id == currentCondition.automationValue);
                                triggerValueDisplays.push(salesStatus.code);
                                break;
                            case 'client_profile_id':
                                const clientProfile = this.all_codes.client_profile.find(element => element.id == currentCondition.automationValue);
                                triggerValueDisplays.push(clientProfile.code);
                                break;
                            case 'contract_type_id':
                                const contractType = this.all_codes.contract_type.find(element => element.id == currentCondition.automationValue);
                                triggerValueDisplays.push(contractType.code);
                                break;
                            case 'marketing_status_id':
                                const marketingStatus = this.all_codes.marketing_status.find(element => element.id == currentCondition.automationValue);
                                triggerValueDisplays.push(marketingStatus.code);
                                break;
                            case 'lead_from_id':
                                const leadFrom = this.all_codes.lead_from.find(element => element.id == currentCondition.automationValue);
                                triggerValueDisplays.push(leadFrom.code);
                                break;
                            case 'office_id':
                                const office = this.all_codes.office.find(element => element.id == currentCondition.automationValue);
                                triggerValueDisplays.push(office.code);
                                break;
                            case 'products_and_services_id':
                                const productsAndService = this.all_codes.products_and_services.find(element => element.id == currentCondition.automationValue);
                                triggerValueDisplays.push(productsAndService.code);
                                break;
                            case 'company_types_id':
                                const companyType = this.company_types.find(element => element.id == currentCondition.automationValue);
                                triggerValueDisplays.push(companyType.code);
                                break;
                            case 'contact_types_id':
                                const contactType = this.contact_types.find(element => element.id == currentCondition.automationValue);
                                triggerValueDisplays.push(contactType.code);
                                break;
                            case 'estimator_id':
                            case 'account_manager_id':
                            case 'take_off_person_id':
                            case 'user_id':
                                const user = this.all_codes.users.find(element => element.id == currentCondition.automationValue);
                                triggerValueDisplays.push(user.name);
                                break;
                            case 'dead_date':
                            case 'pre_bid':
                            case 'bid_date':
                            case 'contract_date':
                            case 'followup':
                            case 'estimated_contract_date':
                                triggerValueDisplays.push(moment(currentCondition.automationValue).format('YYYY-MM-DD'));
                                break;
                            case 'contract_amount':
                            case 'base_bid':
                            case 'gross_margin_percentage':
                            case 'labor_hours':
                                triggerValueDisplays.push(parseFloat(currentCondition.automationValue).toFixed(2));
                                break;
                            case 'team_contact_status':
                                const teamContactStatus = this.team_contact_statuses.find(element => element.id == currentCondition.automationValue);
                                triggerValueDisplays.push(teamContactStatus.code);
                                break;
                            default:
                                let projectSalesBehaviors = [];
                                projectSalesBehaviors = this.$parent.$parent.getProjectSalesBehaviors();
                                let contactSalesBehaviors = [];
                                contactSalesBehaviors = this.$parent.$parent.getContactSalesBehaviors();

                                if(projectSalesBehaviors.includes(this.form.automation_field) || contactSalesBehaviors.includes(this.form.automation_field)) {
                                    triggerValueDisplays.push(moment(currentCondition.automationValue).format('YYYY-MM-DD'));
                                    salesBehaviorId = this.form.field_object.id
                                    break;
                                }
                                else {
                                    triggerValueDisplays.push(currentCondition.automationValue);
                                    break;
                                }
                        }
                    }
                }

                let condition = {
                    triggerLabel: label,
                    triggerField: this.form.automation_field,
                    triggerOperator: this.form.trigger_operator,
                    triggerValues: triggerValues,
                    triggerValueDisplays: triggerValueDisplays,
                    customFieldId: customFieldId,
                    salesBehaviorId: salesBehaviorId,
                    isRecordDetailCustomField: isRecordDetailCustomField
                };

                let index = oldFinalConditions.findIndex(element => element.triggerField == this.form.automation_field);
                if(index !== -1) {
                    this.$parent.finalConditions.splice(index, 1);
                    this.$parent.finalConditions.push(condition);
                }
                else {
                    if(this.conditionEditIndex !== -1) {
                        this.$parent.finalConditions.splice(this.conditionEditIndex, 1)
                    }
                    this.$parent.finalConditions.push(condition);
                }

                this.form.automation_field = null;
                this.form.trigger_operator = 'equal to';
                this.conditionEditIndex = -1;
                this.resetConditions();
            }
        },
        editCondition(condition, index) {
            this.form.automation_field = condition.triggerField;
            this.form.trigger_operator = condition.triggerOperator;
            this.conditions = [];
            for(let i = 0; i < condition.triggerValues.length; i++) {
                this.conditions.push({automationValue: condition.triggerValues[i]});
            }
            this.selectField(condition.triggerField, true);
            this.conditionEditIndex = index;
            this.openModal();
        },
        triggerOperatorChanged() {
            if(this.form.trigger_operator !== 'equal to') {
                this.conditions.splice(1);
            }
        }
    }
}
</script>

<style scoped>
.modal-header {
    background-color: inherit !important;
    border-bottom: none !important;
}
.field-height {
    min-height: 37px;
    max-height: 37px;
    border: 1px solid #b0b9bf
}
.btn-light-red {
    background: #f87676;
}
</style>
